import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./Pages/Home";
import More from "./Pages/More";
import About from "./Pages/About";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/more" element={<More />} />
        <Route exact path="/about" element={<About />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
